
import { Component, Watch, Mixins, Prop } from "vue-property-decorator";
import formMixin from "../mixins/form";
import formValidationMixin from "../mixins/form-validation";

@Component
export default class DateRange extends Mixins(formMixin, formValidationMixin) {
  localValue: string = "";

  @Prop({ default: "" })
  value: string;

  @Prop({ default: null })
  position: string;

  created() {
    this.localValue = this.value;
  }

  get dateRange() {
    if (this.localValue) {
      const dateData = this.localValue.split(" ~ ");
      const startDate = dateData[0].indexOf("null") < 0 ? dateData[0] : null;
      const endDate = dateData[1].indexOf("null") < 0 ? dateData[1] : null;
      return {
        start: startDate,
        end: endDate
      };
    } else {
      return "";
    }
  }
  set dateRange(obj) {
    this.localValue = obj ? `${obj.start} ~ ${obj.end}` : "";
  }

  @Watch("value")
  valueChanged(val) {
    this.localValue = val;
  }

  @Watch("localValue")
  localValueChanged(val) {
    this.$emit("input", val);
  }

  reset() {
    this.localValue = "";
  }
}
